import { render, staticRenderFns } from "./IndividualScheduleDetailData.vue?vue&type=template&id=28023608&scoped=true"
import script from "./IndividualScheduleDetailData.vue?vue&type=script&lang=js"
export * from "./IndividualScheduleDetailData.vue?vue&type=script&lang=js"
import style0 from "./IndividualScheduleDetailData.vue?vue&type=style&index=0&id=28023608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28023608",
  null
  
)

export default component.exports